import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import utils from './utils'

import { getItems, getPendingItems } from './item'
import { getCounts } from './info'
import { getOffers, getPendingOffers } from './offer'
const status = utils.initStatus([
	'getEmployees',
	'deleteEmployee',
	'addEmployee',
	'updateEmployee',
	'approveResource',
])

const initialState = {
	employees: {
		data: [],
	},
	default: '',

	status,
}
export const getEmployees = createAsyncThunk('employee/getEmployees', async (data, thunkAPI) => {
	try {
		const { currBranch, token, user, type } = utils.getAuth(thunkAPI.getState())

		if (!token || type != 'merchant')
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/list/employees/${currBranch}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
		res.data.user = user
		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})
export const deleteEmployee = createAsyncThunk(
	'employee/deleteEmployee',
	async (empId, thunkAPI) => {
		try {
			const { currBranch, token, type } = utils.getAuth(thunkAPI.getState())

			if (!token || type != 'merchant')
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.delete(`/merchant/delete/employee/${currBranch}`, {
				headers: { Authorization: `Bearer ${token}` },
				data: { empId },
			})

			if (res.status == 200) {
				thunkAPI.dispatch(getEmployees())
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const addEmployee = createAsyncThunk('employee/addEmployee', async (employee, thunkAPI) => {
	try {
		const { currBranch, token, type } = utils.getAuth(thunkAPI.getState())

		if (!token || type != 'merchant')
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.post(`/merchant/add/employee/${currBranch}`, employee, {
			headers: { Authorization: `Bearer ${token}` },
		})

		if (res.status == 200) {
			thunkAPI.dispatch(getEmployees())
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const updateEmployee = createAsyncThunk(
	'employee/updateEmployee',
	async (employee, thunkAPI) => {
		try {
			const { currBranch, token, type } = utils.getAuth(thunkAPI.getState())

			if (!token || type != 'merchant')
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.post(`/merchant/update/res/employee/${currBranch}`, employee, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})

			if (res.status == 200) {
				thunkAPI.dispatch(getEmployees())
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const approveResource = createAsyncThunk(
	'employee/approveResource',
	async ({ resource, data }, thunkAPI) => {
		try {
			const { currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.put(`/merchant/approve/${resource}/${currBranch}`, data, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				if (resource == 'item') {
					thunkAPI.dispatch(getItems())
					thunkAPI.dispatch(getPendingItems())
				} else {
					thunkAPI.dispatch(getOffers())
					thunkAPI.dispatch(getPendingOffers())
				}
				thunkAPI.dispatch(getCounts())
				return res.data
			}

			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err, { debug: true })
		}
	}
)

export const slice = createSlice({
	name: 'employee',
	initialState,
	reducers: {
		clearState: (state, { payload }) => {
			utils.clearState(state, status, payload)
		},
	},
	extraReducers: {
		/*
        Get Employees
        */
		[getEmployees.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			state.employees = data.filter(employee => employee.email.value != payload.user.email)
			utils.handleSuccess(state.status.getEmployees, { message: message, status: 200 })

			return state
		},
		[getEmployees.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getEmployees, payload?.data),
		[getEmployees.pending]: state => utils.handleLoading(state.status.getEmployees),

		/*
        Delete Employee
        */
		[deleteEmployee.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.choice = data

			utils.handleSuccess(state.status.deleteEmployee, { message: message, status: 200 })

			return state
		},
		[deleteEmployee.rejected]: (state, { payload }) =>
			utils.handleError(state.status.deleteEmployee, payload?.data),
		[deleteEmployee.pending]: state => utils.handleLoading(state.status.deleteEmployee),

		/*
        Add Employee
        */
		[addEmployee.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			utils.handleSuccess(state.status.addEmployee, { message: message, status: 200 })

			return state
		},
		[addEmployee.rejected]: (state, { payload }) =>
			utils.handleError(state.status.addEmployee, payload?.data),
		[addEmployee.pending]: state => utils.handleLoading(state.status.addEmployee),

		/*
        Update Employee
        */
		[updateEmployee.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			utils.handleSuccess(state.status.updateEmployee, { message: message, status: 200 })

			return state
		},
		[updateEmployee.rejected]: (state, { payload }) =>
			utils.handleError(state.status.updateEmployee, payload?.data),
		[updateEmployee.pending]: state => utils.handleLoading(state.status.updateEmployee),

		/*
        Approve Resource
        */
		[approveResource.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			utils.handleSuccess(state.status.approveResource, { message: message, status: 200 })

			return state
		},
		[approveResource.rejected]: (state, { payload }) =>
			utils.handleError(state.status.approveResource, payload?.data),
		[approveResource.pending]: state => utils.handleLoading(state.status.approveResource),
	},
})

export const { clearState } = slice.actions
export default slice.reducer
